import styled from '@emotion/styled';
import { Typography } from 'src/components/atoms';

interface Props {
  description: string;
}

const StyledDescription = styled(Typography)`
  font-size: 12px;
  max-height: 5.5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const MymePreviewDescription = ({ description }: Props) => {
  return <StyledDescription variant='body2'>{description}</StyledDescription>;
};
